import { render, staticRenderFns } from "./KisiSorgulaForm.vue?vue&type=template&id=0d78c428"
import script from "./KisiSorgulaForm.vue?vue&type=script&lang=ts"
export * from "./KisiSorgulaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports